import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  canAccessUserManagement,
  canAccessPropertySetup,
  canAccessSettings,
  canAccessAnalytics } from
'../utils/roleCheck';

export default function ProtectedRoute({
  children,
  requireUserManagement = false,
  requirePropertySetup = false,
  requireSettings = false,
  requireAnalytics = false
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>);

  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check specific permissions
  if (requireUserManagement && !canAccessUserManagement(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requirePropertySetup && !canAccessPropertySetup(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireSettings && !canAccessSettings(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAnalytics && !canAccessAnalytics(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}